import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'
import EAIcon from '@/modules/images/footer/ea-icon.svg'

import type { Legal } from './data/types'

export const LegalSection = ({
  links,
  isShowEALogo,
}: {
  links: Legal[]
  isShowEALogo: boolean
}) => {
  const { t } = useTranslation('navigation')

  return (
    <Flex flexDirection={['column', 'column', 'row']}>
      <Flex flexDirection={['column', 'row']} alignItems="start">
        <Typography
          variant="p"
          fontSize={[12, 11]}
          lineHeight={'11px'}
          fontWeight={400}
          color="#A0A9BE"
          marginRight={[0, 2, 3]}
          mb={[1, 0, 0]}
        >
          Copyright © 2018 - {new Date().getFullYear()} Crypto.com. All rights
          reserved.
        </Typography>
        <Flex alignItems="center" flexWrap="wrap">
          {links.map(({ key, name, href }, index) => (
            <Flex
              key={key}
              paddingRight={1}
              marginRight={1}
              borderRight={'1px solid rgba(244, 244, 244, 0.5)'}
              mt={[1, 0, 0]}
            >
              <Link href={href} isExternal={true}>
                <Typography
                  variant="p"
                  fontSize={[12, 11]}
                  lineHeight={'11px'}
                  fontWeight={500}
                  color="#A0A9BE"
                >
                  {t(`footer.${key}`, name)}
                </Typography>
              </Link>
            </Flex>
          ))}
          <Flex key={'cookie_law'} mt={[1, 0, 0]}>
            <Typography
              variant="p"
              fontSize={[12, 11]}
              fontWeight={500}
              color="#A0A9BE"
              mt={[1, 0, 0]}
            >
              <span
                className="ot-sdk-show-settings"
                style={{ cursor: 'pointer' }}
              >
                Cookie Preferences
              </span>
            </Typography>
          </Flex>
        </Flex>
      </Flex>
      {isShowEALogo && (
        <Box ml={[null, null, 'auto']} mt={[2, 2, 0]}>
          <Link href={'https://www.essentialaccessibility.com/cryptocom'}>
            <img src={EAIcon} alt={eaLogoAlt} height={22} />
          </Link>
        </Box>
      )}
    </Flex>
  )
}

const eaLogoAlt =
  'This icon serves as a link to download the eSSENTIAL Accessibility assistive technology app for individuals with physical disabilities.  It is featured as part of our commitment to diversity and inclusion.'
